import React from "react";
import {
  ArrowDownToLine,
  ArrowUpFromLine,
  FileClock,
  Search,
  Settings2,
  SlidersHorizontal,
} from "lucide-react";

const EntryTypeStep = ({ onSelect, onBrowseAll, onManualEntry, onSupplierInvoice }) => {
  const startingPoints = [
    {
      id: "supplier_invoice",
      name: "Registrera en faktura att betala",
      description: "Lägg in en leverantörsfaktura nu och matcha betalningen när den sker.",
      icon: FileClock,
      onClick: onSupplierInvoice,
    },
    {
      id: "purchase",
      name: "Jag betalade på annat sätt",
      description: "Till exempel med ett privat kort, kontanter eller ett konto som inte är anslutet.",
      icon: ArrowUpFromLine,
      onClick: () => onSelect("purchase"),
    },
    {
      id: "sale",
      name: "Jag fick betalt på annat sätt",
      description: "Till exempel kontant, privat eller till ett konto som inte är anslutet.",
      icon: ArrowDownToLine,
      onClick: () => onSelect("sale"),
    },
    {
      id: "other",
      name: "Bokför något annat",
      description: "Överföring, skatt, lön, ägarhändelse, rättelse eller annan bokföringspost.",
      icon: Settings2,
      onClick: () => onSelect("other"),
    },
  ];

  return (
    <div className="enhanced-step-content">
      <div style={{ marginBottom: "1.25rem" }}>
        <h2 style={{ fontSize: "1.15rem", marginBottom: "0.35rem" }}>Hur vill du börja?</h2>
        <p style={{ color: "#64748b", margin: 0 }}>
          Välj den beskrivning som ligger närmast. Valet används bara för att hitta relevanta mallar.
        </p>
      </div>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
        gap: "0.75rem",
      }}>
        {startingPoints.map(({ id, name, description, icon: Icon, onClick }) => (
          <button
            key={id}
            type="button"
            onClick={onClick}
            style={{
              appearance: "none",
              background: "white",
              border: "1px solid #dbe3ec",
              borderRadius: "10px",
              padding: "1rem",
              textAlign: "left",
              cursor: "pointer",
              display: "flex",
              alignItems: "flex-start",
              gap: "0.75rem",
              minHeight: "118px",
            }}
          >
            <span style={{
              display: "inline-flex",
              padding: "0.5rem",
              borderRadius: "8px",
              background: "#f1f5f9",
              color: "#475569",
              flexShrink: 0,
            }}>
              <Icon size={20} />
            </span>
            <span>
              <strong style={{ display: "block", color: "#1e293b", fontSize: "0.9rem", marginBottom: "0.35rem" }}>
                {name}
              </strong>
              <span style={{ display: "block", color: "#64748b", fontSize: "0.78rem", lineHeight: 1.45 }}>
                {description}
              </span>
            </span>
          </button>
        ))}
      </div>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
        gap: "0.75rem",
        borderTop: "1px solid #e2e8f0",
        marginTop: "1.5rem",
        paddingTop: "1.5rem",
      }}>
        <button
          type="button"
          onClick={onBrowseAll}
          style={{
            background: "#f8fafc",
            border: "1px solid #cbd5e1",
            color: "#334155",
            padding: "0.875rem 1rem",
            borderRadius: "8px",
            fontWeight: 600,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
          }}
        >
          <Search size={17} />
          Sök bland alla mallar
        </button>
        <button
          type="button"
          onClick={onManualEntry}
          style={{
            background: "white",
            border: "1px solid #cbd5e1",
            color: "#334155",
            padding: "0.875rem 1rem",
            borderRadius: "8px",
            fontWeight: 600,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
          }}
        >
          <SlidersHorizontal size={17} />
          Börja med tomma konteringsrader
        </button>
      </div>
    </div>
  );
};

export default EntryTypeStep;
